import { StoreState } from '@app/shared/rsm';
import { Filter } from '@app/shared/components/filter/filter.component';

import { OrganizationAttribute } from './attribute.model';

export interface AttributesState extends StoreState {
  term: string;
  filters: any;
  orgId: number;
  pageNum: number;
  take: number;
  totalResults: number;
}

export interface AttributesAPI {
  search: (term: string) => void;
  filter: (filterEvent: { filters: Filter[]; id: string }) => void;
  changePage: (pageNum: number) => void;
  changePageSize: (take: number) => void;
}

/**
 * ViewModel is a union type of State + Computed + API
 */
export type AttributesViewModel = AttributesState & AttributesAPI;

/**
 * Initialization for AttributeState
 * @returns
 */
export function initState(): AttributesState {
  return {
    orgId: undefined,
    term: '',
    filters: undefined,
    pageNum: 1,
    take: 10,
    totalResults: undefined,
  };
}

export type AttributesStore = AttributesState & {
  ids: string[];
  entities: Record<string, OrganizationAttribute>;
};
